import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [dropOpen, setDropOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const handleLogout = () => { logout(); navigate('/'); };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="nav-wrap">
          <Link to="/" className="nav-logo">
            <div className="nav-logo-mark">NG</div>
            <span>NextGenHub Life</span>
          </Link>

          <div className="nav-links">
            <Link to="/services" className={isActive('/services')}>Services</Link>
            <Link to="/portfolio" className={isActive('/portfolio')}>Work</Link>
            <Link to="/blog" className={isActive('/blog')}>Blog</Link>
            <Link to="/about" className={isActive('/about')}>About</Link>
            <Link to="/contact" className={isActive('/contact')}>Contact</Link>
          </div>

          <div className="nav-right">
            {user ? (
              <div className="nav-user" onClick={() => setDropOpen(o => !o)}>
                <div className="nav-avatar" style={{ background: 'linear-gradient(135deg,#9747FF,#E040FB)' }}>
                  {user.avatar}
                </div>
                <span className="nav-username">{user.name.split(' ')[0]}</span>
                <span className="nav-chevron">{dropOpen ? '▲' : '▼'}</span>
                {dropOpen && (
                  <div className="nav-dropdown">
                    <Link to="/dashboard" className="nav-drop-item">Dashboard</Link>
                    <Link to="/profile" className="nav-drop-item">Profile</Link>
                    {user.role === 'admin' && <Link to="/admin" className="nav-drop-item">Admin Panel</Link>}
                    <button className="nav-drop-item danger" onClick={handleLogout}>Log out</button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <Link to="/login" className="nav-login">Log in</Link>
                <Link to="/get-quote" className="btn-ink nav-cta">Get started →</Link>
              </>
            )}
            <button className="nav-menu-btn" onClick={() => setMenuOpen(o => !o)} aria-label="Menu">
              <span /><span /><span />
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`mob-menu${menuOpen ? ' open' : ''}`}>
        <button className="mob-close" onClick={() => setMenuOpen(false)}>✕</button>
        <Link to="/services">Services</Link>
        <Link to="/portfolio">Work</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/about">About</Link>
        <Link to="/contact">Contact</Link>
        {user ? (
          <>
            <Link to="/dashboard" className="mob-dash">Dashboard</Link>
            <button onClick={handleLogout} className="mob-logout">Log out</button>
          </>
        ) : (
          <>
            <Link to="/login">Log in</Link>
            <Link to="/get-quote" className="btn-ink" style={{ marginTop: 12, borderRadius: 10 }}>Get started →</Link>
          </>
        )}
      </div>
    </>
  );
}
